var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "aceEditor",
    class: { userSizable: _vm.userSizable },
    attrs: { id: _vm.editorId },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }